import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

import { UPDATE_BIDS_DATA } from '../../modules/bulkBidding/bulkBidding';

const SELECT_BID = 'Select Bid';

const DropDownBid = ({ disabled, bidIncrements, lotRef, canUnSelect = false }) => {
  const dispatch = useDispatch();
  const selectedBids = useSelector(state => state.bulkBidding.selectedBids);

  const bidValue = selectedBids[lotRef] ? `$ ${selectedBids[lotRef]}` : SELECT_BID;

  if (canUnSelect) {
    bidIncrements = [SELECT_BID, ...bidIncrements];
  }

  return (
    <UncontrolledDropdown className="w-100 mb-3">
      <DropdownToggle caret color="white" disabled={disabled}>
        <span>{bidValue}</span>
      </DropdownToggle>
      <DropdownMenu>
        {bidIncrements.map(value => (
          <DropdownItem
            key={value}
            className="w-100 text-clamp-2 small-important"
            onClick={() => {
              dispatch({
                type: UPDATE_BIDS_DATA,
                payload: [lotRef, value === SELECT_BID ? null : value]
              });
            }}
          >
            {`${value === SELECT_BID ? SELECT_BID : `$ ${value}`} `}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default DropDownBid;
